export default __webpack_public_path__ + "static/media/46b.caeb90e3.svg";